(() => {
  function updateRatings() {
    document.querySelectorAll('[data-mc-georgina]').forEach(section => {
      const reviewSection = document.querySelector('[data-mc-photo-reviews]');
      const ratings = Array.from(reviewSection?.querySelectorAll('[data-mc-review-rating]') || []).map(card => Number(card.dataset.mcReviewRating)).filter(rating => rating >= 1 && rating <= 5);
      const reviewLink = section.querySelector('[data-mc-rating-link]');
      const ratingLabel = section.querySelector('[data-mc-rating-label]');
      if (ratings.length && reviewLink && ratingLabel) {
        reviewLink.hidden = false;
        reviewLink.href = '#' + reviewSection.id;
        const score = (ratings.reduce((sum,rating) => sum + rating,0) / ratings.length).toFixed(1);
        ratingLabel.textContent = ratingLabel.dataset.format.replace('__rating__',score).replace('__count__',String(ratings.length));
      } else if (reviewLink) reviewLink.hidden = true;
    });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-mc-georgina]').forEach(section => {
      if (section.dataset.mcGeorginaReady) return;
      section.dataset.mcGeorginaReady = 'true';
      const form = section.querySelector('.product-single__form');
      const sizes = section.querySelectorAll('[data-mc-size-input]');
      const button = form?.querySelector('[data-add-to-cart]');
      const label = button?.querySelector('[data-add-to-cart-text]');
      const master = form?.querySelector('[data-product-select]');
      const message = section.querySelector('[data-mc-size-message]');
      if (!form || !sizes.length || !button || !master) return;
      sizes.forEach(input => input.required = true);
      const needsSize = () => !Array.from(sizes).some(input => input.checked);
      function sync() {
        const missing = needsSize();
        section.dataset.mcSizeRequired = String(missing);
        if (missing) {
          if (master.value !== '') master.value = '';
          if (button.disabled) button.disabled = false;
          if (button.classList.contains('disabled')) button.classList.remove('disabled');
          if (label.textContent !== section.dataset.mcChooseSize) label.textContent = section.dataset.mcChooseSize;
        } else if (message && !message.hidden) message.hidden = true;
      }
      function chooseSize(event) {
        if (!needsSize()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (message) message.hidden = false;
        section.querySelector('.variant-wrapper--mc-size').scrollIntoView({behavior:'smooth',block:'center'});
        sizes[0].focus({preventScroll:true});
      }
      button.addEventListener('click', chooseSize, true);
      form.addEventListener('submit', chooseSize, true);
      section.addEventListener('change', () => queueMicrotask(sync));
      new MutationObserver(sync).observe(button,{attributes:true,childList:true,subtree:true});
      sync();

    });
    updateRatings();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', () => init());
  document.addEventListener('shopify:section:unload', () => queueMicrotask(updateRatings));
})();

